/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Btn_Showmore1Inputs */

const en_btn_showmore1 = /** @type {(inputs: Btn_Showmore1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Show more`)
};

/**
* | output |
* | --- |
* | "Show more" |
*
* @param {Btn_Showmore1Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const btn_showmore1 = /** @type {((inputs?: Btn_Showmore1Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Btn_Showmore1Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_btn_showmore1(inputs)
});
export { btn_showmore1 as "btn_showMore" }